// @ts-nocheck

import React from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../client';
import Modal from '../../../components/Modal';
import RoundedButton from '../../../components/RoundedButton';
import ScaleTransitionGroup from '../../../components/ScaleTransitionGroup';
import { ModalContentSpacing, ModalFormat } from '../../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../../DOMElements';
import theme from '../../../styled-components/dark';
import { type KLCollectibleId, type KLComfortId } from '../types/collectible';
import { type KLNotificationType } from '../types/notification';
import { type KLRound } from '../types/round';

import KLNotification from './KLNotification';

const Wrapper = styled.div`
  font-family: 'BettingKalam';
  color: white;
  position: relative;
`;

const Skippers = styled.div`
  position: absolute;
  bottom: 0em;
  width: 100%;
  height: 4em;
  padding: 0em 1em;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 1em;
  }
`;

const sharedBtnStyle = css`
  font-family: 'BettingArchivoNarrow';
`;

const SkipAllButton = styled(RoundedButton)`
  flex: 1;
  ${sharedBtnStyle}
`;

const NextButton = styled(RoundedButton)`
  flex: 1;
  ${sharedBtnStyle}
`;

const OkButton = styled(RoundedButton)`
  flex: 1;
  ${sharedBtnStyle}
`;

type KLNotificationsViewerProps = {
  className?: string;
  notification: {
    type: KLNotificationType;
    data: {
      betslipReference: string;
      collectibleId?: KLCollectibleId;
      comfortId?: KLComfortId;
      remainingKnifes?: number;
      roundId?: KLRound;
      amount?: number;
      previousTime?: number;
      totalTime?: number;
      votes?: number;
      hasCollar?: boolean;
    };
  };
  currentRound: KLRound;
  skipAll: () => void;
  skipCurrent: () => void;
  isLast: boolean;
};

const KLNotificationsViewer = ({
  className = '',
  notification,
  currentRound,
  skipAll,
  skipCurrent,
  isLast,
}: KLNotificationsViewerProps) => {
  return createPortal(
    <ScaleTransitionGroup>
      <Modal
        contentSpacing={ModalContentSpacing.NONE}
        format={Target.__MOBILE__ ? ModalFormat.FULLSCREEN : ModalFormat.DESKTOP}
        zIndex={theme.ZIndices.klnotifs}
        hasNavBarSpacing={Target.__MOBILE__}
        hideOverlay
        disableScrollView
      >
        <Wrapper className={`modal-clickable-elements ${className}`}>
          <KLNotification type={notification.type} data={notification.data} currentRound={currentRound} />
          <Skippers>
            {!isLast ? (
              <SkipAllButton
                backgroundColor={theme.KLNotificationViewer.skipAllBtn.backgroundColor}
                borderColor={theme.KLNotificationViewer.skipAllBtn.backgroundColor}
                color={theme.KLNotificationViewer.skipAllBtn.color}
                label={'Tout passer'}
                onClick={skipAll}
              />
            ) : null}
            {!isLast ? (
              <NextButton
                backgroundColor={theme.KLNotificationViewer.nextBtn.backgroundColor}
                borderColor={theme.KLNotificationViewer.nextBtn.backgroundColor}
                color={theme.KLNotificationViewer.nextBtn.color}
                label={'Suivant'}
                onClick={skipCurrent}
              />
            ) : null}
            {isLast ? (
              <OkButton
                backgroundColor={theme.KLNotificationViewer.okBtn.backgroundColor}
                borderColor={theme.KLNotificationViewer.okBtn.backgroundColor}
                color={theme.KLNotificationViewer.okBtn.color}
                label={'OK'}
                onClick={skipAll}
              />
            ) : null}
          </Skippers>
        </Wrapper>
      </Modal>
    </ScaleTransitionGroup>,
    getPortalRootDOMElement(),
  );
};

export default KLNotificationsViewer;
